<div class="page-not-found">
  <div class="wrapper">
    <video id="vid" #vid preload="auto" autoplay="true" muted="muted" (loadeddata)="loaded()" [ngClass]="{ hidden: isLoading }" playsinline>
      <source [src]="videoUrl" type="video/mp4" />
    </video>
  </div>
</div>
